class Packet {
  constructor () {
    this.cmd = null
    this.retain = false
    this.qos = 0
    this.dup = false
    this.length = -1
    this.topic = null
    this.payload = null
  }
}

module.exports = Packet



//////////////////
// WEBPACK FOOTER
// ./~/mqtt-packet/packet.js
// module id = 249
// module chunks = 73